import { useState, useContext } from "react";
import { RegisterClientRequest } from "../../../data/clients/model/Client";
import { registerClient } from "../../../data/clients/repository/ClientsRepository";
import { ClientContext } from "../../../context/ClientContext";
import { formatCPFOrCNPJ, formatPhone } from "../../../utils/FormatUtils";

export function useCreateClientModal(closeModal) {
  const { addClient } = useContext(ClientContext);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const onSaveClick = async (e) => {
    e.preventDefault();
    const response = await registerClient(new RegisterClientRequest(code, name, cnpj, email, phone));
    if (response) {
      addClient(true);
    } else {
      addClient(false);
    }
    closeModal();
  };

  const handleCode = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setCode(value);
  };

  const handleName = (e) => {
    setName(e.target.value);
  };

  const handleCnpj = (e) => {
    setCnpj(formatCPFOrCNPJ(e.target.value));
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePhone = (e) => {
    setPhone(formatPhone(e.target.value));
  };

  const isFormValid = name && code && cnpj && email && phone;
  return {
    code,
    name,
    cnpj,
    email,
    phone,
    handleCode,
    handleName,
    handleCnpj,
    handleEmail,
    handlePhone,
    onSaveClick,
    isFormValid
  };
}